import { useEffect, useState } from 'react';
import { OptionsBar } from './OptionsBar';
import { ViewTicketModal } from './ViewTicketModal';
import { SupportTicket } from '../../../types/commonTypes';
import { xsScreen } from '../../../lib/constants';
import { ViewTicketsTable } from './ViewTicketsTable';
import { Card } from '../../../components/Card';
import { useMediaQuery } from '../../../hooks/useMediaQuery';

interface Props {
  ticketData: SupportTicket[];
  loading: boolean;
  setActiveSite(item: any): void;
  dateRange: {
    start: Date;
    end: Date;
  };
  setDateRange(item: { start: any; end: any }): void;
  pendingOnly: boolean;
  setViewAll(item: boolean): void;
  updateSubmitted: boolean;
  setUpdateSubmitted(bool: boolean): void;
}

export const ViewTickets = ({
  ticketData,
  loading,
  setActiveSite,
  dateRange,
  setDateRange,
  pendingOnly,
  setViewAll,
  updateSubmitted,
  setUpdateSubmitted,
}: Props) => {
  const [viewTicketOpen, setViewTicketOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState<SupportTicket>();
  const isMobile = useMediaQuery(xsScreen);

  useEffect(() => {
    if (ticketData !== undefined && selectedTicket) {
      setSelectedTicket(
        ticketData.find(
          (ticket) => ticket.displayID === selectedTicket.displayID
        )
      );
    }
  }, [ticketData, selectedTicket]);

  const handleSelect = (ticket: SupportTicket) => {
    setSelectedTicket(ticket);
    setViewTicketOpen(true);
  };

  return (
    <div className="flex flex-col md:flex-row gap-6 w-full mt-6">
      <OptionsBar
        pendingOnly={pendingOnly}
        onChange={setViewAll}
        setActiveSite={setActiveSite}
        dateRange={dateRange}
        setDateRange={setDateRange}
        loading={loading}
      />
      <Card className="inline-flex gap-4 h-[580px] p-4" fullWidth>
        <ViewTicketsTable
          isMobile={isMobile}
          loading={loading}
          onSelectedTicket={handleSelect}
          pendingOnly={pendingOnly}
          selectedTicket={selectedTicket}
          tickets={ticketData}
        />
        <ViewTicketModal
          ticketData={selectedTicket}
          open={viewTicketOpen}
          onClose={setViewTicketOpen}
          updateSubmitted={updateSubmitted}
          setUpdateSubmitted={setUpdateSubmitted}
        />
      </Card>
    </div>
  );
};
